import axios from '../../axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TCreateComment, TCommentBase, TError } from '@onesource/schemas';
import { getPostCommentsQueryKey } from './get-comments';
import { getPostQueryKey } from '../posts/get-post';

/**
 * Hook to create a new comment on a post
 * Automatically invalidates comments list and post (to update comment count)
 *
 * @param postId - Post ID (UUID) where the comment will be created
 */
export const useCreateComment = (postId: string) => {
  const queryClient = useQueryClient();

  return useMutation<TCommentBase, TError, TCreateComment>({
    mutationFn: async data => {
      const res = await axios.post<TCommentBase>(`/community-hub/posts/${postId}/comments`, data);
      return res.data;
    },
    onSuccess: () => {
      // Invalidate comments list to trigger refetch
      queryClient.invalidateQueries({ queryKey: getPostCommentsQueryKey(postId) });
      // Invalidate post to update comment count
      queryClient.invalidateQueries({ queryKey: getPostQueryKey(postId) });
    },
  });
};
